module.exports = __webpack_public_path__ + "img/Path_66833.f7c4ae30.svg";